<template>
<div>
	<div  :class="ccss"></div>
	<div class="modal fade" ref="modalErro" tabindex="-1" role="dialog">
		<div class="iphone-x-top"></div>
		<div class="modal-dialog" style="z-index: 100000;" :style="{'max-width': _isMobile ? '100%' : '65%'  }">

			<div class="modal-content" >
				<div class="modal-header" style="background:#DDD">
					<h5 class="modal-title">
						<fa-icon icon="sad-tear"></fa-icon>
						Aconteceu um erro no sistema.
					</h5>

					<a href="#" class="fechar-modal" style="margin:-0.5rem -0.5rem -1rem auto"  @click.prevent="modal.hide()" >
						<fa-icon icon="times"/>
					</a>
				</div>
				<div class="modal-body" style="padding: 2em">
					<div style="color: #B71C1C;font-size: 1.2em" v-html="error"></div>
				</div>
			</div>
		</div>
	</div>

	<transition enter-active-class="animated fadeIn" v-if="exibirLoad">
		<div class="processar" style="z-index: 99999999999" >
			<div>
				<strong>{{text.toUpperCase()}}...</strong><br />
				<br />
				<fa-icon icon="sync-alt" spin size="2x"/>
			</div>
		</div>
    </transition>
</div>
</template>

<script>

import $mobile from '../../library/mobile'
import  {Modal}  from '../../library/boostrap-native-v4'

export default {
    data () {
        return {
            type:"",
			text:"",
			title: "",
			error: "",
			response: {body: {error: ""} },
			exibirLoad: false,
			modal: null,
			ccss: null,
        }
	},

	computed: {
		_isMobile () {
			return $mobile.isMobile()
		}
	},

    methods: {

		erro(response, type){

			if (!this.$parent) {
				this.$mount()
				document.body.appendChild(this.$el)
			}

			if(type = "request"){
				if(response.status == 0){
					this.error = "<div style='text-align: center'>O Servidor está fora do ar <br/> ou <br/> Você está sem internet</div>"
				} else if(response.response !== undefined) {
					this.error = response.response
				} else {
					this.error = response
				}
			}

			if(type == "string"){
				this.error = response
			}

			this.ccss = 'modal-backdrop'

			this.modal = new Modal(this.$refs.modalErro, {
				backdrop: 'static',
				show: true
			})

			this.modal.show()

			this.$refs.modalErro.addEventListener('hide.bs.modal', (event) => {
				this.ccss = null
			}, false);
		},

		show(tipo, texto){

            this.type = tipo
			this.text = texto.toUpperCase()

			this.title = 'Sucesso!'

			if(this.type == 'info'){
				this.title = 'Informação:'
			}

			if(this.type == 'error' || this.type == 'warning'){
				this.title = 'Atenção!'
			}

			this.$msg[this.type](this.text.toUpperCase(), {
				title: this.title.toUpperCase(),
				position: 'top-center',
				timeout: 4000
			});
		},

		loadIn(text){

			if (!this.$parent) {
				this.$mount()
				document.body.appendChild(this.$el)
			}

			this.exibirLoad = true
			this.text = text
		},

		loadOut(){
			this.exibirLoad = false
		}
    }
}
</script>

<style>

.processar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .9;
    background-color: #000;
    z-index: 9999999999999;
}

.processar div {
	top: 36%;
	left: 50%;
	margin-left: -200px; /* A metade de sua largura. */
	position: absolute;
	width: 400px;
	color: #FFF;
	text-align: center;
	z-index: 9999999999999;
}
</style>




// WEBPACK FOOTER //
// src/components/notify/main.vue